import Header from "../component/header/Header"
import Footer from "../component/footer/Footer"
import GridFooter from "../component/grid/GridFooter"
import ProjectCard from "../component/grid/ProjectCard"
import projet from '../image/projet.png'

import img1 from '../image/p1.jpg'
import img2 from '../image/p2.jpg'
import img3 from '../image/p3.jpg'
import img4 from '../image/p4.jpg'
import img5 from '../image/p5.jpg'
import img6 from '../image/p6.jpg'
import img7 from '../image/p7.jpg'
import img8 from '../image/p8.jpg'
import img9 from '../image/p9.jpg'
import img10 from '../image/p10.jpg'
import img11 from '../image/p11.jpg'
import img12 from '../image/p12.jpg'
import img13 from '../image/p13.jpg'
import img14 from '../image/p14.jpg'
import img15 from '../image/p15.jpg'
import img16 from '../image/p16.jpg'
import img17 from '../image/p17.jpg'
import img18 from '../image/p18.jpg'
import img19 from '../image/p19.jpg'
import img20 from '../image/p20.jpg'
import img21 from '../image/p21.jpg'
import img22 from '../image/p22.jpg'
import img23 from '../image/p23.jpg'
import img24 from '../image/p24.jpg'
import img25 from '../image/p25.jpg'
import img27 from '../image/p27.jpg'
import img29 from '../image/p29.jpg'
import img28 from '../image/p28.jpg'
import img30 from '../image/p30.jpg'
import img32 from '../image/p32.jpg'

import img31 from '../image/projet_7/inspection-chantier-ingenieur.jpg'
import img33 from '../image/projet_7/travaux-de-construction-routière-2.jpg'
import img34 from '../image/projet_7/travaux-de-construction-routière-3.jpg'
import img35 from '../image/projet_7/travaux-de-construction-routière.jpg'

import img36 from '../image/projet_8/construction-usine-traitement-bafoula-1.jpg'
import img37 from '../image/projet_8/construction-usine-traitement-bafoula-2.jpg'
import img38 from '../image/projet_8/construction-usine-traitement-bafoula.jpg'

import img39 from '../image/projet_9/construction-forage-au-gabon-1.jpg'
import img40 from '../image/projet_9/construction-forage-au-gabon-2.jpg'
import img41 from '../image/projet_9/construction-forage-au-gabon-3.jpg'
import img42 from '../image/projet_9/construction-forage-au-gabon-4.jpg'
import img43 from '../image/projet_9/construction-forage-au-gabon.jpg'

// --- NOUVEAUX IMPORTS PROJET 10 ---
import img44 from '../image/projet_10/installation-piezometre-foreuse-bs03-okouma.jpg'
import img45 from '../image/projet_10/preparation-piezometre-bassin-bs03.jpg'
import img46 from '../image/projet_10/mise-en-place-inclinometre-foreuse-bs03.jpg'
import img47 from '../image/projet_10/equipe-technique-ouvrage-piezometre-bs03.jpg'
import img48 from '../image/projet_10/releve-donnees-piezometre-bs03.jpg'
import img49 from '../image/projet_10/materiel-chantier-compresseur-bs03.jpg'

import { useEffect } from "react"
import { t } from "i18next"

export default function Projet() {
    // Définition des slides (inchangée)
    const slides1 = [img1, img2, img3, img4, img5]
    const slides2 = [img6, img7, img8, img9, img10]
    const slides3 = [img11, img12, img13, img14, img15]
    const slides4 = [img16, img17, img18, img19, img20]
    const slides5 = [img20, img21, img22, img23, img24, img25]
    const slides6 = [img27, img28, img29, img30, img32]
    const slides7 = [img31, img32, img33, img34, img35]
    const slides8 = [img36, img37, img38]
    const slides9 = [img39, img40, img41, img42, img43]
    const slides10 = [img44, img45, img46, img47, img48, img49]

    useEffect(() => {
        const id = window.location.hash.substr(1)
        if (id) {
            setTimeout(() => window.scrollTo({ top: 700, behavior: 'smooth' }), 100)
        } else {
            window.scrollTo(0, 0)
        }
    }, [])

    // Configuration des projets pour éviter la répétition JSX
    const projects = [
        {
            slides: slides10,
            title: t("projetTitle10"),
            client: "ERAMET COMILOG",
            projectLabel: t("projetTitle10"),
            objet: t("objet10"),
            date: t("date10"),
        },
        {
            slides: slides7,
            title: t("projetTitle7"),
            client: "AFCONS",
            projectLabel: t("projets7"),
            objet: t("objet7"),
            date: t("date7"),
        },
        {
            slides: slides9,
            title: t("projetTitle9"),
            client: "CTRI (Comité pour la Transition et la Restauration des Institutions)",
            projectLabel: t("projetTitle9"),
            objet: t("objet9"),
            date: t("date9"),
        },
        {
            slides: slides8,
            title: t("projetTitle8"),
            client: "Nouvelle Gabon Mining",
            projectLabel: t("projetTitle8"),
            objet: t("objet8"),
            date: t("date8"),
        },
        {
            slides: slides2,
            title: t("projetTitle6"),
            client: "Nouvelle Gabon Mining",
            projectLabel: t("projetTitle6"),
            objet: t("objet6"),
            date: t("date6"),
        },
        {
            slides: slides1,
            title: t("projetTitle1"),
            client: "Nouvelle Gabon Mining",
            projectLabel: t("projetTitle1"),
            objet: t("objet1"),
            date: t("date1"),
        },
        {
            slides: slides4,
            title: t("projetTitle3"),
            client: "DIEP COMILOG",
            projectLabel: t("projetTitle3"),
            objet: t("objet3"),
            date: t("date3"),
        },
        {
            slides: slides3,
            title: t("projetTitle2"),
            client: "C2020 COMILOG",
            projectLabel: t("projetTitle2"),
            objet: t("objet2"),
            date: t("date2"),
        },
        {
            slides: slides6,
            title: t("projetTitle5"),
            client: "C2020 COMILOG",
            projectLabel: t("projetTitle5"),
            objet: t("objet5"),
            date: t("date5"),
        },
        {
            slides: slides5,
            title: t("projetTitle4"),
            client: t("client4"),
            projectLabel: t("projetTitle4"),
            objet: t("objet4"),
            date: t("date4"),
        },
    ]

    return (
        <div className="bg-gray-50 min-h-screen">
            <Header image={projet} titre1={t('nos')} titre2={t('realisation')} menu="projet" />

            <section className="max-w-10xl mx-auto py-10">
                {projects.map((p, i) => (
                    <ProjectCard
                        key={i}
                        slides={p.slides}
                        title={p.title}
                        client={p.client}
                        projectLabel={p.projectLabel}
                        objet={p.objet}
                        date={p.date}
                        reverse={i % 2 === 1} // alternance gauche/droite
                    />
                ))}
            </section>

            <GridFooter />
            <Footer />
        </div>
    )
}